import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import {Config, Regex} from '../../util';

const modalRoot = document.getElementById('root');

class Detail extends Component {
	constructor(props){
		super(props);
		this.state = {
            defaultImg: "/static/img/close_icon_d.png",
            overImg: "/static/img/close_icon_s.png",
            changeImgFlag: false,
        };
        this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
        this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
	}

    handleOnMouseOver(){
        this.setState({changeImgFlag: true});
    }
    handleOnMouseLeave(){
        this.setState({changeImgFlag: false});
    }

	render() {
        const {
            defaultImg,
            overImg,
            changeImgFlag
        } = this.state;
        const {
            handleDetailClose,
            detailInfo
        } = this.props;
        const channelName = detailInfo && _.keyBy(Config.logoUrl, 'epgId')[detailInfo.epgid].id;
        const formattedStime = moment(detailInfo.start, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss').split(' ');
        const formattedETime = moment(detailInfo.stop, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss').split(' ');
        const insertDate = moment(detailInfo.insDt, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss');
        const modifyDate = moment(detailInfo.editDt, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss');
        const price = detailInfo && Regex.getPriceComma(detailInfo.price);
		return ReactDOM.createPortal(
			<div id="modal-wrap">
                <div className = "modal detail-container">
                    <div className="header">
                        <div>편성정보 상세보기</div>
                        <div onClick={handleDetailClose} onMouseOver={this.handleOnMouseOver} onMouseLeave={this.handleOnMouseLeave}>
                          <span className="icon modal-close"></span>
                        </div>
                    </div>

                    <div className="detail-wrapper">
                        <div className="content-item-group">
                            <div className="content-item">
                                <div className="caption">
                                    채널명
                                </div>
                                <div className="value">
                                    {`${channelName} (${detailInfo.epgid})`}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    프로그램 일시
                                </div>
                                <div className="value">
                                    {`${formattedStime[0]} ${formattedStime[1]} ~ ${formattedETime[0]} ${formattedETime[1]}`}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    등록일시
                                </div>
                                <div className="value">
                                    {insertDate}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    수정일시
                                </div>
                                <div className="value">
                                    {modifyDate}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    프로그램명
                                </div>
                                <div className="value">
                                    {detailInfo.title}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    프로그램 설명
                                </div>
                                <div className="value">
                                    <textarea readOnly defaultValue={detailInfo.desc} />
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    카테고리
                                </div>
                                <div className="value">
                                    {detailInfo.category}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    상품가격
                                </div>
                                <div className="value">
                                    {price}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    상품명
                                </div>
                                <div className="value">
                                    {detailInfo.director}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    재방송 여부
                                </div>
                                <div className="value">
                                    {detailInfo.returnYn === "1" && "Y"}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    특집프로그램
                                </div>
                                <div className="value">
                                    {detailInfo.rating}
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="caption">
                                    쇼호스트
                                </div>
                                <div className="value">
                                    {detailInfo.actor}
                                </div>
                            </div>

                        </div>
                    </div>
                    
                    <div className="footer">
                        <button type="button" onClick={handleDetailClose}>닫 기</button>
                    </div>

                </div>
			</div>
		, modalRoot);
	}
}

const mapStateToProps = state => {
    return {
      detailInfo: state.detailInfo,
    }
  }
  
  

  
  Detail = connect(mapStateToProps)(Detail);


export default Detail;


// WEBPACK FOOTER //
// ./src/components/modal/Detail.js